export const pinnedLeftShadow =
  'after:absolute after:top-0 after:right-0 after:h-full after:w-3 after:bg-gradient-to-r after:from-black/10 after:to-transparent after:pointer-events-none';

export const pinnedRightShadow =
  'after:absolute after:top-0 after:left-0 after:h-full after:w-3 after:bg-gradient-to-l after:from-black/10 after:to-transparent after:pointer-events-none';

export const pinnedColumnBg =
  'group-odd:bg-white group-even:bg-surface-subtle group-hover:bg-surface-soft';

export const borderColumnBg = `
  before:absolute
  before:inset-y-0
  before:content-['']
  before:-z-10
  group-odd:before:bg-white
  group-even:before:bg-surface-subtle
  group-hover:before:bg-surface-soft
`;

export const borderLeftPinnedColumnBg = `
  before:left-0
  before:right-3

  ${borderColumnBg}
`;

export const borderRightPinnedColumnBg = `
  before:left-3
  before:right-0

  ${borderColumnBg}
`;
